"use strict";

const disableStyle = (styleName) => {
  const sheets = Array.from(document.styleSheets);
  const sheet = sheets.find(({ href }) => href && href.endsWith(styleName));
  if (sheet) {
    sheet.disabled = true;
  }
};

(function ($) {
  $(function () {
    if ($(".js-talently").length) {
      var careerObserver = new MutationObserver(modifyCareers);

      careerObserver.observe(document.querySelector(".js-talently"), {
        childList: true,
        subtree: true,
        attributes: false,
        characterData: false,
      });

      function modifyCareers(e) {
        $(".js-talently .tl-job").each(function (e) {
          var $this = $(this);
          if (!$this.hasClass("changed")) {
            var title = $this.find(".tl-title-text").text();
            var address = $this.find(".tl-address").text();
            var link = $this.find(".tl-title").attr("href");

            $(".js-carreer").append(html`
              <div class="col-md-6">
                <div class="card card--career">
                  <h4 data-mh="mh-career-title">${title}</h4>

                  <ul class="microdata microdata--group" itemscope="" itemtype="http://schema.org/LocalBusiness">
                    <li class="microdata__address" itemprop="address">
                      <a href="https://maps.google.com/maps?q=${address}" target="_blank">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-map-pin">
                          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                          <circle cx="12" cy="10" r="3"></circle></svg
                        >${address}
                      </a>
                    </li>
                  </ul>

                  <div class="button__wrapper">
                    <a href="${link}" class="button button--secondary-yellow" target="_blank">${localize.translations.career_button_text}</a>
                  </div>
                </div>
              </div>
            `);
            $this.addClass("changed");
          }
        });

        disableStyle("talentlyftWidget.min.css");
      }
    }
  });
})(jQuery);
